var _excluded = ["payload"];
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { FlattenedSign } from '../flattened/sign.js';
import { JWSInvalid } from '../../util/errors.js';
var IndividualSignature = /*#__PURE__*/function () {
  function IndividualSignature(sig, key, options) {
    _classCallCheck(this, IndividualSignature);
    this.parent = sig;
    this.key = key;
    this.options = options;
  }
  return _createClass(IndividualSignature, [{
    key: "setProtectedHeader",
    value: function setProtectedHeader(protectedHeader) {
      if (this.protectedHeader) {
        throw new TypeError('setProtectedHeader can only be called once');
      }
      this.protectedHeader = protectedHeader;
      return this;
    }
  }, {
    key: "setUnprotectedHeader",
    value: function setUnprotectedHeader(unprotectedHeader) {
      if (this.unprotectedHeader) {
        throw new TypeError('setUnprotectedHeader can only be called once');
      }
      this.unprotectedHeader = unprotectedHeader;
      return this;
    }
  }, {
    key: "addSignature",
    value: function addSignature() {
      var _this$parent;
      return (_this$parent = this.parent).addSignature.apply(_this$parent, arguments);
    }
  }, {
    key: "sign",
    value: function sign() {
      var _this$parent2;
      return (_this$parent2 = this.parent).sign.apply(_this$parent2, arguments);
    }
  }, {
    key: "done",
    value: function done() {
      return this.parent;
    }
  }]);
}();
export var GeneralSign = /*#__PURE__*/function () {
  function GeneralSign(payload) {
    _classCallCheck(this, GeneralSign);
    this._signatures = [];
    this._payload = payload;
  }
  return _createClass(GeneralSign, [{
    key: "addSignature",
    value: function addSignature(key, options) {
      var signature = new IndividualSignature(this, key, options);
      this._signatures.push(signature);
      return signature;
    }
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var jws, i, signature, flattened, _yield$flattened$sign, payload, rest;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (this._signatures.length) {
                _context.n = 1;
                break;
              }
              throw new JWSInvalid('at least one signature must be added');
            case 1:
              jws = {
                signatures: [],
                payload: ''
              };
              i = 0;
            case 2:
              if (!(i < this._signatures.length)) {
                _context.n = 7;
                break;
              }
              signature = this._signatures[i];
              flattened = new FlattenedSign(this._payload);
              flattened.setProtectedHeader(signature.protectedHeader);
              flattened.setUnprotectedHeader(signature.unprotectedHeader);
              _context.n = 3;
              return flattened.sign(signature.key, signature.options);
            case 3:
              _yield$flattened$sign = _context.v;
              payload = _yield$flattened$sign.payload;
              rest = _objectWithoutProperties(_yield$flattened$sign, _excluded);
              if (!(i === 0)) {
                _context.n = 4;
                break;
              }
              jws.payload = payload;
              _context.n = 5;
              break;
            case 4:
              if (!(jws.payload !== payload)) {
                _context.n = 5;
                break;
              }
              throw new JWSInvalid('inconsistent use of JWS Unencoded Payload (RFC7797)');
            case 5:
              jws.signatures.push(rest);
            case 6:
              i++;
              _context.n = 2;
              break;
            case 7:
              return _context.a(2, jws);
          }
        }, _callee, this);
      }));
      function sign() {
        return _sign.apply(this, arguments);
      }
      return sign;
    }()
  }]);
}();